import { observer } from 'mobx-react-lite';
import { ReactElement, useEffect, useState } from 'react';
import { InteractionStoresName } from 'sdk';

import { Involve } from '../../../components/involve';
import { InvolveContainer } from '../../../components/layout/involveContainer';
import { useSDK } from '../../App';

const Interaction = observer((): ReactElement | null => {
	const [interactionPriority, setInteractionPriority] = useState<InteractionStoresName>(
		InteractionStoresName.involve
	);
	const sdk = useSDK();
	const { uiStateStore, showcaseStatusStore, involveStore, holdStore } = sdk;

	useEffect(() => {
		if (involveStore.activeInteraction?.scenario && involveStore.interactionEvent) {
			setInteractionPriority(InteractionStoresName.involve);
		}
	}, [involveStore.activeInteraction?.scenario, involveStore.interactionEvent]);

	useEffect(() => {
		if (holdStore.activeInteraction?.scenario && holdStore.interactionEvent && holdStore.holdIsTriggered) {
			setInteractionPriority(InteractionStoresName.hold);
		}
	}, [holdStore.activeInteraction?.scenario, holdStore.interactionEvent, holdStore.holdIsTriggered]);
	if (uiStateStore.opened || !showcaseStatusStore.online || showcaseStatusStore.blocked) {
		return null;
	}
	return (
		<>
			{interactionPriority === InteractionStoresName.hold
				? holdStore.activeInteraction &&
				  holdStore.holdIsTriggered &&
				  holdStore.interactionEvent && (
						<InvolveContainer store={holdStore}>
							<Involve store={holdStore} message={holdStore.interactionEvent} />
						</InvolveContainer>
				  )
				: involveStore.activeInteraction &&
				  involveStore.interactionEvent && (
						<InvolveContainer store={involveStore}>
							<Involve store={involveStore} message={involveStore.interactionEvent} />
						</InvolveContainer>
				  )}
		</>
	);
});

export { Interaction };
